import { Form, Modal } from "react-bootstrap"
import { useForm } from "react-hook-form";
import InputRHF from "../InputRHF";
import { useState } from "react";
import Cargando from "../Cargando";
import * as yup from "yup";
import { yupResolver } from "@hookform/resolvers/yup";
import { reenviarEmail } from "../../screens/Ingreso/handler";
import fondoNegro from "../../assets/Fondos2026/fondoNaranjaH.jpg"

const ModalReenviar = ({ modalReenviar, hide }) => {

    const schema = yup.object({
        numero_tramite: yup.string()
            .required('N° trámite requerido').max(11, 'Máximo 11 dígitos'),
        // .max(4, 'Se requiere solo 4 dígitos'),
        email: yup.string().email('Email invalido').required('Email requerido'),
        documento: yup.number().transform((value, originalValue) => (originalValue === "" ? undefined : value))
            .required('DNI requerido').min(99999, 'El mínimo es 100.000').max(99999999, 'El máximo es 99.999.999'),

        // correo_electronico_vrf: yup.string().required('Email requerido').oneOf([yup.ref('correo_electronico'), null], 'Los emails deben ser iguales'),
        // telefono: yup.string().transform((value, originalValue) => (originalValue === "" ? undefined : value))
        //     .required('Teléfono requerido').min(8, "El teléfono debe tener al menos 8 dígitos")
        //     .max(15, "El teléfono no debe exceder los 15 dígitos"),
    })

    const {
        register,
        handleSubmit,
        setError,
        formState: { errors },
        clearErrors,
        watch,
    } = useForm({
        defaultValues: {
            documento: "",
            email: "",
            numero_tramite: ""
        },
        resolver: yupResolver(schema)
    });

    const [loading, setLoading] = useState(false);

    const onSubmit = (data) => {
        reenviarEmail(data, setLoading)

    }

    return (
        <Modal
            show={modalReenviar}
            onHide={hide}
            centered
            size='lg'
        >
            {/* <Modal.Header style={{ backgroundColor: "#548ACB" }} closeButton> */}
            <Modal.Header style={{ backgroundColor: "#FFF" }} closeButton>
                <Modal.Title className='fw-bolder fs-5' style={{ color: "#52278A" }}>
                    <section>
                        <p>
                            Reenviar email de CÓDIGOS
                        </p>
                    </section>
                </Modal.Title>
            </Modal.Header>
            <Modal.Body className='d-flex justify-content-center p-0' style={{ background: "#3C3C40" }}>
                <section
                    className="w-100 py-4"
                    style={{ backgroundImage: `url(${fondoNegro})`, backgroundSize: 'cover', backgroundPosition: 'center' }}
                >
                    <Form
                        onSubmit={handleSubmit(onSubmit)}
                        className='d-flex flex-column align-items-center mx-auto px-3' style={{maxWidth:"500px"}}>
                        <InputRHF fase={"registrar"} className={`col-12 d-flex flex-column align-items-center gap-2`} label={'INGRESÁ EL DOCUMENTO:'} campo={'documento'} type="number" register={register} errors={errors} placeholder={'DOCUMENTO . . .'} />
                        <InputRHF fase={"registrar"} className={`col-12 d-flex flex-column align-items-center gap-2`} label={'INGRESÁ EL N° TRÁMITE:'} campo={'numero_tramite'} type="number" register={register} errors={errors} placeholder={'N° DE TRÁMITE . . .'} />
                        <InputRHF fase={"registrar"} className={`col-12 d-flex flex-column align-items-center gap-2`} label={'EMAIL:'} campo={'email'} type="email" register={register} errors={errors} placeholder={'EMAIL . . .'} />
                        <p className="mb-4">Revisar la casilla "Spam"</p>
                        <>
                            {
                                !loading ? (
                                    <div className="d-flex flex-column align-items-center gap-3 "
                                    >
                                        <button
                                            // onClick={() => { setExiste(false), clearErrors('documento') }}
                                            type="submit"
                                            //  disabled={watch('documento').length < 7 || watch('documento').length > 8}
                                            className={`enviar `}
                                            // style={{ backgroundColor: (watch('documento').length < 7 || watch('documento').length > 8) ? "gray" : "#A349FE", color: "#FFF", boxShadow: "none", border: "none" }} >ENVIAR</button>
                                            style={{ backgroundColor: "#A349FE", color: "#FFF", boxShadow: "none", border: "none" }} >REENVIAR</button>

                                        {/* {rta.error && <p className="text-danger">{rta.error}</p>} */}
                                    </div>
                                ) : (
                                    <Cargando fase="ingreso" />
                                )
                            }
                        </>
                    </Form>
                </section>
            </Modal.Body>
        </Modal >
    )
}

export default ModalReenviar;


